export class DataTable {
  columns: DataColumn[];
  autoSize?: boolean;
  hasActions = true;
}

export class DataColumn {
  key: string;
  header: string;
  sort?: boolean;
  sortBy?: string;
  size?: number;
  type?: 'constants' | 'date' | 'badge' | 'template' | 'default' = 'default';
  textConstants?: { [key: number]: string };
  badgeConstants?: { [key: number]: string };
  position?: 'start' | 'center' | 'end' = 'center';
}
